import '@salonomy/design-tokens/tokens.css';
import '@salonomy/ui/styles.css';
import './styles/global.css';
import './styles/screens.css';
import './features/diary/diary.css';
import './features/queue/queue.css';
import './features/search/ws14.css';
import './features/notifications/notifications.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './app.js';
import { initErrorReporting } from './lib/report.js';

// WS14 — register the global error/unhandledrejection listeners ONCE, before render, so uncaught
// errors and rejected promises (incl. ApiClientError, whose requestId we lift) reach the LOG-ONLY
// ingest. initErrorReporting is idempotent, so StrictMode's double-invoke never doubles the listeners.
initErrorReporting();

// Offline-first: keep the installed app shell fresh in the background (brief WS2).
registerSW({ immediate: true });

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
